export default __webpack_public_path__ + "static/media/coworker-landingpage-sheet.82b2041f.png";